import React from 'react';
import PropTypes from 'prop-types';
import { Set } from 'immutable';
import { MDCTextfieldFoundation } from '@material/textfield/dist/mdc.textfield';


class TextField extends React.Component {

    constructor(props) {
        super(props);

        let rootClassNames = ['mdc-text-field'];

        if (props.fullWidth) {
            rootClassNames.push('mdc-text-field--fullwidth');
        }

        if (props.dense) {
            rootClassNames.push('mdc-text-field--dense');
        }

        if (props.rootClassName) {
            rootClassNames.push(props.rootClassName);
        }

        this.inputElm = null;
        this.state = {
            value: '',
            rootClassNames: new Set(rootClassNames),
            labelClassNames: new Set()
        };
        this.mdcTextfieldFoundation = new MDCTextfieldFoundation({
            addClass: className => this.setState(prevState => ({
                rootClassNames: prevState.rootClassNames.add(className)
            })),
            removeClass: className => this.setState(prevState => ({
                rootClassNames: prevState.rootClassNames.remove(className)
            })),
            addClassToLabel: className => this.setState(prevState => ({
                labelClassNames: prevState.labelClassNames.add(className)
            })),
            removeClassFromLabel: className => this.setState(prevState => ({
                labelClassNames: prevState.labelClassNames.remove(className)
            })),
            addClassToHelptext: () => {},
            removeClassFromHelptext: () => {},
            helptextHasClass: () => false,
            setHelptextAttr: () => {},
            removeHelptextAttr: () => {},
            registerInputFocusHandler: (handler) => {this.inputElm && this.inputElm.addEventListener('focus', handler)},
            deregisterInputFocusHandler: (handler) => {this.inputElm && this.inputElm.removeEventListener('focus', handler)},
            registerInputBlurHandler: (handler) => {this.inputElm && this.inputElm.addEventListener('blur', handler)},
            deregisterInputBlurHandler: (handler) => {this.inputElm && this.inputElm.removeEventListener('blur', handler)},
            registerInputInputHandler: (handler) => {this.inputElm && this.inputElm.addEventListener('input', handler)},
            deregisterInputInputHandler: (handler) => {this.inputElm && this.inputElm.removeEventListener('input', handler)},
            registerInputKeydownHandler: (handler) => {this.inputElm && this.inputElm.addEventListener('keydown', handler)},
            deregisterInputKeydownHandler: (handler) => {this.inputElm && this.inputElm.removeEventListener('keydown', handler)},
            getNativeInput: () => this.inputElm
        });
    }

    onChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    componentDidMount() {
        // this.mdcTextfieldFoundation.init();
    }
    componentWillUnmount() {
        // this.mdcTextfieldFoundation.destroy();
    }

    render() {
        let classNames = ["mdc-text-field__input"];
        if (this.props.textFieldClassName) {
            classNames.push(this.props.textFieldClassName);
        }
        return (
            <div className={this.state.rootClassNames.toJS().join(' ')}>
                <input
                    type="text"
                    value={this.state.value}
                    id={this.props.id}
                    className={classNames.join(' ')}
                    autoFocus={this.props.autoFocus}
                    placeholder={this.props.placeholder}
                    ref={(elm) => {this.inputElm = elm;}}
                    onChange={event => this.onChange(event)}
                />
            </div>
        );
    }

}

TextField.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    fullWidth: PropTypes.bool,
    dense: PropTypes.bool,
    autoFocus: PropTypes.bool,
    onChange: PropTypes.func,
    rootClassName: PropTypes.string,
    textFieldClassName: PropTypes.string
};
TextField.defaultProps = {
    fullWidth: false,
    dense: false,
    autoFocus: false
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/mdc/TextField.js